<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col cols="12" lg="4">
        <div class="form-group">
          <label
                  for="excmcyclictask_caseType"
                  class="form-control-label">{{$t('views.excmcyclictask.form.caseType')}}:</label>
          <fg-input :error="violations.caseType">
            <el-select
                    id="excmcyclictask_caseType"
                    :class="['select-default', isInvalid('caseType') ? 'select-danger' : '']"
                    filterable
                    remote
                    reserve-keyword
                    v-model="item.caseType">
              <el-option v-for="option in caseTypesOptions"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.title"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
          <div
                  v-if="isInvalid('taskType')"
                  class="invalid-feedback">{{ violations.taskType }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="4">
        <div class="form-group">
          <label
                  for="excmcyclictask_caseGenre"
                  class="form-control-label">{{$t('views.excmcyclictask.form.caseGenre')}}:</label>
          <fg-input :error="violations.caseGenre">
            <el-select
                    id="excmcyclictask_caseGenre"
                    :class="['select-default', isInvalid('caseGenre') ? 'select-danger' : '']"
                    filterable
                    remote
                    reserve-keyword
                    v-model="item.caseGenre">
              <el-option v-for="option in caseGenreOptions"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.title"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
          <div
                  v-if="isInvalid('taskType')"
                  class="invalid-feedback">{{ violations.taskType }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="4">
        <div class="form-group">
          <label
                  for="excmcyclictask_taskType"
                  class="form-control-label">{{$t('views.excmcyclictask.form.taskType')}}:</label>
          <fg-input :error="violations.taskType">
            <el-select
                    id="excmcyclictask_taskType"
                    :class="['select-default', isInvalid('taskType') ? 'select-danger' : '']"
                    filterable
                    remote
                    reserve-keyword
                    v-model="item.taskType">
              <el-option v-for="option in taskTypeOptions"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.title"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
          <div
                  v-if="isInvalid('taskType')"
                  class="invalid-feedback">{{ violations.taskType }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" lg="4">
        <div class="form-group">
          <label
            for="excmcyclictask_daysInterval"
            class="form-control-label">{{$t('views.excmcyclictask.form.frequency')}}:</label>
          <input
            id="excmcyclictask_daysInterval"
            v-model="item.daysInterval"
            :class="['form-control', isInvalid('daysInterval') ? 'is-invalid' : '']"
            type="number"
            required="true"
            placeholder=""
            min="1"
            @input="handleUpdateField('daysInterval', $event.target.value)">
          <div
            v-if="isInvalid('daysInterval')"
            class="invalid-feedback">{{ violations.daysInterval }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="4">
        <div class="form-group">
          <label
            for="excmcyclictask_dateFrom"
            class="form-control-label">{{$t('views.excmcyclictask.form.dateFrom')}}:</label>
          <fg-input :error="violations.dateFrom">
            <el-date-picker
                    :picker-options="{firstDayOfWeek: 1}"
                    v-model="item.dateFrom"
                    type="date"
                    :placeholder="$t('views.excmcyclictask.form.dateFrom')"
                    default-time="12:00:00">
            </el-date-picker>
          </fg-input>
          <div
            v-if="isInvalid('dateFrom')"
            class="invalid-feedback">{{ violations.dateFrom }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="4">
        <div class="form-group">
          <label
            for="excmcyclictask_dateTo"
            class="form-control-label">{{$t('views.excmcyclictask.form.dateTo')}}:</label>
          <fg-input :error="violations.dateTo">
            <el-date-picker
                    :picker-options="{firstDayOfWeek: 1}"
                    v-model="item.dateTo"
                    type="date"
                    :placeholder="$t('views.excmcyclictask.form.dateTo')"
                    default-time="12:00:00">
            </el-date-picker>
          </fg-input>
          <div
            v-if="isInvalid('dateTo')"
            class="invalid-feedback">{{ violations.dateTo }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" lg="4">
        <div class="form-group">
          <label
            for="excmcyclictask_agreement"
            class="form-control-label">{{$t('views.excmcyclictask.form.agreement')}}:</label>
          <fg-input :error="violations.agreement">
            <el-select
              id="excmcyclictask_caseType"
              :class="['select-default', isInvalid('agreement') ? 'select-danger' : '']"
              filterable
              remote
              reserve-keyword
              v-model="item.agreement">
              <el-option v-for="option in agreementsOptions"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.agreementNumber"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
          <div
            v-if="isInvalid('agreement')"
            class="invalid-feedback">{{ violations.agreement }}</div>
        </div>
      </b-col>
    </b-row>
    <button type="submit" class="btn btn-success">{{ $t('buttons.submit') }}</button>
    <b-btn v-if="$route.name === 'EXCMAgreementShow'" variant="danger" @click="closeModal()">{{ $t('buttons.cancel') }}</b-btn>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      taskTypeOptions: [],
      caseGenreOptions: [],
      caseTypesOptions: [],
      agreementsOptions: []
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  created () {
    this.getEXCMTaskTypes()
    this.channelEXCMTaskTypes = this.$store.state.Pusher.subscribe('e_x_c_m_task_types')
    this.channelEXCMTaskTypes.bind('e_x_c_m_task_types', data => {
      this.getEXCMTaskTypes()
    })
    this.getCaseGenres()
    this.channelEXCMTaskTypes = this.$store.state.Pusher.subscribe('e_x_c_m_case_genres')
    this.channelEXCMTaskTypes.bind('e_x_c_m_case_genres', data => {
      this.getCaseGenres()
    })
    this.getCaseTypes()
    this.channelCaseTypes = this.$store.state.Pusher.subscribe('e_x_c_m_case_types')
    this.channelCaseTypes.bind('e_x_c_m_case_types', data => {
      this.getCaseTypes()
    })
    this.getAgreements()
    this.channelAgreements = this.$store.state.Pusher.subscribe('e_x_c_m_agreements')
    this.channelAgreements.bind('e_x_c_m_case_types', data => {
      this.getAgreements()
    })
  },

  methods: {
    getAgreements () {
      let params = {
        'state': 1,
        'pagination': false
      }
      this.$http.get('api/e_x_c_m_agreements', {
        params
      })
        .then(response => {
          this.agreementsOptions = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    getCaseTypes () {
      let params = {
        'state': 1,
        'pagination': false
      }
      this.$http.get('api/e_x_c_m_case_types', {
        params
      })
        .then(response => {
          this.caseTypesOptions = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    getCaseGenres () {
      let params = {
        'state': 1,
        'pagination': false
      }
      this.$http.get('api/e_x_c_m_case_genres', {
        params
      })
        .then(response => {
          this.caseGenreOptions = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    getEXCMTaskTypes () {
      let params = {
        'state': 1,
        'pagination': false
      }
      this.$http.get('api/e_x_c_m_task_types', {
        params
      })
        .then(response => {
          this.taskTypeOptions = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },

    closeModal () {
      if (this.item['@id']) {
        this.$store.state.modals.excmcyclictask.update.close = 1
      } else {
        this.$store.state.modals.excmcyclictask.create.close = 1
      }
    },

    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
